import { ARTICLES_REGEXP } from '../constants';

export default function isIndexArticle(indexName: string) {
  return ARTICLES_REGEXP.test(indexName);
}
